import { TagToken } from 'tag/ts/smart_tag/model/enums/TagToken';
import { FreewheelModel } from 'tag/ts/tag/model/ads/freewheel/FreewheelModel';
import { TagConstants } from 'tag/ts/tag/model/TagConstants';
import { AdSDK } from 'tag/ts/tag/model/type/ads/AdSDK';
import { Manifest } from 'tag/ts/tag/model/type/Manifest';
import { AbstractAssetPlaybackUtility } from 'tag/ts/tag/player/adapters/avia/utilities/AbstractAssetPlaybackUtility';
import { FWUtilities } from 'tag/ts/tag/utilities/FWUtilities';
export class AssetUrlPlaybackUtility extends AbstractAssetPlaybackUtility {
    constructor(argument) {
        super({
            name: 'AssetUrlPlaybackUtility',
            ...argument
        });
    }
    getMediaUrl() {
        if (this.isDAIAsset()) {
            return this.#getMediaUrlForDaiAsset();
        }
        return this.#getMediaUrlForNonDaiAsset();
    }
    #getMediaUrlForDaiAsset = () => {
        const adSDKType = this.tag?.model?.adUtilities?.adSetupInfo()?.sdk?.type;
        const isIntl = this.tag.tagUtilities.isInternationalContext(this?.tag);
        const fwUtil = FWUtilities.getInstance();
        const fwModel = new FreewheelModel({ tag: this.tag });
        let mediaUrl;
        if (adSDKType === AdSDK.NONE &&
            !isIntl) {
            mediaUrl = this.#appendIuToDaiSsbUrl(fwUtil.createFWUrl(fwModel, this?.params?.CONTENT?.assetURL));
            this.logger.log('getMediaUrlForDaiAsset', '=> params.CONTENT.assetURL with Freewheel parameters and iu appended:', mediaUrl);
            return mediaUrl;
        }
        mediaUrl = fwUtil.createFWUrl(fwModel, this?.params?.CONTENT?.assetURL);
        this.logger.log('getMediaUrlForDaiAsset', '=> params.CONTENT.assetURL with Freewheel parameters appended:', this?.params?.CONTENT?.assetURL);
        return mediaUrl;
    };
    #appendIuToDaiSsbUrl = (url) => {
        const iuValue = this?.params?.AD?.IMA?.iu || this.#getIUForPartnerID(this.params);
        if (this.isDaiLiveStream()) {
            return this?.utils?.URL?.replaceParam('iu', iuValue, url);
        }
        let manifest = this.tag.model.contentUtilities.assetManifestExtension(url);
        if (this.utils.Type.isString(manifest)) {
            manifest = manifest.toLowerCase();
        }
        if (this.tag.model.contentUtilities.daiAssetURL(url) &&
            (manifest === Manifest.M3U8 || manifest === Manifest.MPD)) {
            return this?.utils?.URL?.replaceParam('iu', iuValue, url);
        }
        this.logger.log('appendIuToDaiSsbUrl', 'could not identify url as DAI SSB stream url... returning url unmodified:', url);
        return url;
    };
    #getMediaUrlForNonDaiAsset = () => {
        this.logger.log('getMediaUrlForNonDaiAsset', '=> params.CONTENT.assetURL: ', this?.params?.CONTENT?.assetURL);
        return this?.params?.CONTENT?.assetURL;
    };
    #getIUForPartnerID = (params = this.params) => {
        const partnerID = this.tag.model.contentUtilities.getPartnerID(params);
        return window.SmartTag.capabilities.isDesktop
            ? TagConstants.getInstance().DAI_IU.desktop.replace(TagToken.PARTNER_ID, partnerID)
            : TagConstants.getInstance().DAI_IU.mobile.replace(TagToken.PARTNER_ID, partnerID);
    };
    #hasFWParams = () => {
        return (this.utils.Type.isObject(this.params?.AD?.FW)
            &&
                (this.#hasFMSParams()
                    ||
                        this.#hasGDPRParams()));
    };
    #hasFMSParams = () => {
        return (this.utils.Type.isObject(this.params?.AD?.FW?.FMS)
            &&
                !this.utils.Type.isEmpty(this.params?.AD?.FW?.FMS));
    };
    #hasGDPRParams = () => {
        return (this.utils.Type.isObject(this.params?.AD?.FW?.GDPR)
            &&
                !this.utils.Type.isEmpty(this.params?.AD?.FW?.GDPR));
    };
}
